import { Button } from '@root/components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaCog } from 'react-icons/fa'
import styled from 'styled-components'

interface Props {
  onClick: () => void
}

export const RecurringInvoiceSettingBadgeButton: React.FC<Props> = ({ onClick }) => {
  const [t] = useTranslation()
  const text = t('invoicing.details.recurrence.badge.setting')
  return (
    <ButtonWrap>
      <Button size="sm" intent="default" icon={<FaCog />} onClick={() => onClick()}>
        {text}
      </Button>
    </ButtonWrap>
  )
}

const ButtonWrap = styled.div`
  align-self: flex-start;
  width: fit-content;
`
